import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useT } from '../lib/i18n';
import { Phone, Globe, Clock, LifeBuoy } from 'lucide-react';

export default function Resources() {
    const { lang } = useT();
    const [data, setData] = useState({ crisis: [], topics: [] });

    useEffect(() => {
        api.get(`/resources?language=${lang}`).then(r => setData(r.data));
    }, [lang]);

    return (
        <div className="max-w-4xl mx-auto px-6 py-10 pb-24" data-testid="resources-page">
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-crisis/10 flex items-center justify-center text-crisis">
                    <LifeBuoy className="w-5 h-5"/>
                </div>
                <div>
                    <h1 className="font-display text-3xl font-bold tracking-tight">
                        {lang === 'en' ? 'When you need more than a conversation' : 'Når du trenger mer enn en samtale'}
                    </h1>
                    <p className="text-inkSoft text-sm">
                        {lang === 'en' ? 'Crisis lines that are open 24/7, free, and confidential.' : 'Nordiske hjelpelinjer – døgnåpne og gratis.'}
                    </p>
                </div>
            </div>

            <div className="mt-8 grid md:grid-cols-2 gap-3" data-testid="crisis-list">
                {data.crisis.map((c, i) => (
                    <div key={i} className="rounded-2xl border border-sand bg-white p-5 hover:border-crisis/40 transition-colors" data-testid={`crisis-${i}`}>
                        <p className="text-xs uppercase tracking-wider text-inkSoft">{c.country}</p>
                        <h3 className="font-display font-semibold text-lg mt-1">{c.name}</h3>
                        <div className="mt-3 space-y-1 text-sm text-ink">
                            <a href={`tel:${c.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:text-crisis font-medium" data-testid={`phone-${i}`}>
                                <Phone className="w-4 h-4"/> {c.phone}
                            </a>
                            <div className="flex items-center gap-2 text-inkSoft">
                                <Globe className="w-4 h-4"/> {c.web}
                            </div>
                            <div className="flex items-center gap-2 text-inkSoft">
                                <Clock className="w-4 h-4"/> {c.hours}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <h2 className="font-display text-xl font-semibold mt-12">
                {lang === 'en' ? 'Common topics to start with' : 'Vanlige samtaletema'}
            </h2>
            <div className="mt-4 grid sm:grid-cols-2 gap-3">
                {data.topics.map(t => (
                    <div key={t.key} className="rounded-2xl border border-sand bg-white p-4" data-testid={`topic-card-${t.key}`}>
                        <p className="font-medium text-ink">{t.label}</p>
                        <p className="text-sm text-inkSoft mt-1 italic">"{t.starter}"</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
